import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { consultDNI, consultRUT, consultCYC, consultRUES } from './OCRAPI';

const initialState = {
  statusDNI: "idle",
  dni: '',

  statusRUT: "idle",
  rut: '',

  statusCYC: "idle",
  cyc: '',

  statusRUES: "idle",
  rues: '',
};

export const dataDNI = createAsyncThunk(
  '/ocr/dni',
  async (data) => {
    const response = await consultDNI(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const dataRUT = createAsyncThunk(
  '/ocr/rut',
  async (data) => {
    const response = await consultRUT(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const dataCYC = createAsyncThunk(
  '/ocr/cyc',
  async (data) => {
    const response = await consultCYC(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const dataRUES = createAsyncThunk(
  '/ocr/rues',
  async (data) => {
    const response = await consultRUES(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const OCRSlice = createSlice({
  name: 'ocr',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
    //#region RTK dataDNI
      .addCase(dataDNI.pending, (state) => {
        state.statusDNI = 'loading';
      })
      .addCase(dataDNI.fulfilled, (state, action) => {
        state.statusDNI = 'fulfilled';
        state.dni = action.payload.data;
      })
      .addCase(dataDNI.rejected, (state) => {
        state.statusDNI = 'rejected';
      })
       //#endregion
      //#region RTK dataRUT
      .addCase(dataRUT.pending, (state) => {
        state.statusRUT = 'loading';
      })
      .addCase(dataRUT.fulfilled, (state, action) => {
        state.statusRUT = 'fulfilled';
        state.rut = action.payload.data;
      })
      .addCase(dataRUT.rejected, (state) => {
        state.statusRUT = 'rejected';
      })
      //#endregion
      //#region RTK dataCYC
      .addCase(dataCYC.pending, (state) => {
        state.statusCYC = 'loading';
      })
      .addCase(dataCYC.fulfilled, (state, action) => {
        state.statusCYC = 'fulfilled';
        state.cyc = action.payload.data;
      })
      .addCase(dataCYC.rejected, (state) => {
        state.statusCYC = 'rejected';
      })
      //#endregion
      //#region RTK dataRUES
      .addCase(dataRUES.pending, (state) => {
        state.statusRUES = 'loading';
      })
      .addCase(dataRUES.fulfilled, (state, action) => {
        state.statusRUES = 'fulfilled';
        state.rues = action.payload.data;
      })
      .addCase(dataRUES.rejected, (state) => {
        state.statusRUES = 'rejected';
      })
      //#endregion
  },
});

export const { reset } = OCRSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatusDNI = (state) => state.ocr.statusDNI;
export const selectDNI = (state) => state.ocr.dni;

export const selectStatusRUT = (state) => state.ocr.statusRUT;
export const selectRUT = (state) => state.ocr.rut;

export const selectStatusCYC = (state) => state.ocr.statusCYC;
export const selectCYC = (state) => state.ocr.cyc;

export const selectStatusRUES = (state) => state.ocr.statusRUES;
export const selectRUES = (state) => state.ocr.rues;

export default OCRSlice.reducer;